@if(loading){<lib-spinner-overlay></lib-spinner-overlay>}

<lib-dba-mat-table tableNameId="debitor" [data]="debitorList" [columnsdef]="columnsdefMain" [importButton]="false"
    [pageSize]="20" [editButton]="permissionService.DebitorSchreiben"
    [createButton]="permissionService.DebitorSchreiben" [deleteButton]="permissionService.DebitorLoeschen"
    [(selectedElement)]="selectedDebitor" (openDialog2)="OpenDialog($event)" [dynamicSize]="true">
</lib-dba-mat-table>